import { checkinApi } from '@/services/api/httpClient';

const ocrActions = {
  async analyzeMedicalOrdersOnOcr({ getters }, { images, unitId }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/ocr?&unitId=${unitId}`;

    try {
      const resp = await checkinApi().post(url, {
        images: images,
        updateAdmission: true,
      });
      return resp.data;
    } catch (error) {
      console.error('Erro ao analisar exames no OCR: ', error);
      return null;
    }
  },
};

export default ocrActions;
